import React from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa6";
import ReactPaginate from "react-paginate";

const Pagination = (props) => {
  return (
    <div className="paginationOuter p-2">
      <div className="d-flex align-items-center justify-content-between m-2">
        <ReactPaginate
          previousLabel={
            <>
              <FaLessThan />
              <span>Prev</span>
            </>
          }
          nextLabel={
            <>
              <span>Next</span>
              <FaGreaterThan />
            </>
          }
          className={props?.totalPages > 1 ? "" : "d-none"}
          breakLabel={"..."}
          breakClassName={"page-item"}
          forcePage={props?.page ? props?.page - 1 : false}
          pageCount={Math.ceil(props?.totalPages ?? 1)}
          marginPagesDisplayed={3}
          onPageChange={(e) => props?.setPage(e.selected + 1)}
          renderOnZeroPageCount={null}
          containerClassName={"pagination position-relative mt-2 pt-3"}
          pageClassName={"page-item"}
          previousClassName={`page-item`}
          previousLinkClassName={"pagination__link"}
          nextClassName={"page-item"}
          nextLinkClassName={"pagination__link"}
          disabledClassName={"pagination__link--disabled"}
          activeClassName={"pagination__link--active"}
          breakLinkClassName={"page-link"}
        />
      </div>
    </div>
  );
};

export default Pagination;
